import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './student-list.scss';
import StudentBox from '../../components/student-box/student-box';
import StudentEmptyList from '../../components/student-empty-list/student-empty-list';

const StudentList = ({ students, onChange, type }) => {
    onChange = onChange || function empty() {};
    const studentItems = (students || []).map(item => (
        <StudentBox key={item.key} student={item} onChange={onChange} />
    ));
    const finalRender = students && students.length === 0 ? (
        <StudentEmptyList
            type={type}
            wholeClass={false}
        />
    ) : studentItems;
    return (
        <div className={css['student-list']}>
            {finalRender}
        </div>
    );
};

StudentList.propTypes = {
    students: PropTypes.array,
    onChange: PropTypes.func,
    type: PropTypes.string
};

export default styleable(css)(StudentList);



// WEBPACK FOOTER //
// ./components/student-list/student-list.js